export class Occurrence {
  id: number;
  name: string;
  idExternal: number;
}
